/** Filipino for the merchant portal, the POS and the public store pages (keyed by the English text). */
export const FIL_MERCHANT: Record<string, string> = {
  "A name you will recognise, e.g. \"Counter 1\".": "Pangalang madali mong makilala, hal. \"Counter 1\".",
  "A supervisor PIN approves voids and refunds at the POS. Give it only to people you trust with that.": "Ang supervisor PIN ang nag-aapruba ng void at refund sa POS. Ibigay lang ito sa mga pinagkakatiwalaan mo.",
  "Above the cap of {cap}. Depending on the program it may be refused or only the cap is paid.": "Lampas sa cap na {cap}. Depende sa programa, maaaring tanggihan o ang cap lang ang babayaran.",
  "Accept the agreement": "Tanggapin ang kasunduan",
  "Account created": "Nagawa na ang account",
  "Account name": "Pangalan sa account",
  "Account number": "Numero ng account",
  "Accreditation": "Akreditasyon",
  "Accreditation {no}, valid until {date}": "Akreditasyon {no}, may bisa hanggang {date}",
  "Active": "Aktibo",
  "Add": "Idagdag",
  "Add an item paid in cash": "Magdagdag ng item na babayaran ng cash",
  "Add cashier": "Magdagdag ng cashier",
  "Add item": "Magdagdag ng item",
  "Add the medicines and goods you sell that are on the approved list.": "Idagdag ang mga gamot at paninda mo na nasa approved list.",
  "Add them in Sales": "Ilagay sa Benta",
  "After you sign in you will set up an authenticator app, because store owners bill the LGU.": "Pagka-sign in, magse-set up ka ng authenticator app dahil ang may-ari ng tindahan ang naniningil sa LGU.",
  "All": "Lahat",
  "All barangays": "Lahat ng barangay",
  "All billings": "Lahat ng billing",
  "All types": "Lahat ng uri",
  "Allow NFC for this site, then try again.": "Payagan ang NFC para sa site na ito, saka subukan ulit.",
  "Already have an account? Sign in": "May account na? Mag-sign in",
  "Amount to bill": "Halagang sisingilin",
  "Amounts": "Mga halaga",
  "An SMS with the balance was sent to the card owner.": "Nagpadala ng SMS na may balanse sa may-ari ng card.",
  "Appeal": "Apela",
  "Apply as an accredited store": "Mag-apply bilang accredited na tindahan",
  "Approved": "Aprubado",
  "Approved by the LGU": "Inaprubahan ng LGU",
  "Assistance balance": "Balanse ng ayuda",
  "Assistance transaction slip": "Slip ng transaksiyon ng ayuda",
  "At least 10 characters. A short sentence is easy to remember.": "Hindi bababa sa 10 karakter. Madaling tandaan ang maikling pangungusap.",
  "Back": "Bumalik",
  "Back to items": "Balik sa mga item",
  "Bank": "Bangko",
  "Bank account for payment": "Bank account para sa bayad",
  "Barangay": "Barangay",
  "Barcode": "Barcode",
  "Barcode {code} is not one of your approved items. Add it as an item paid in cash.": "Ang barcode {code} ay wala sa mga aprubadong item mo. Idagdag ito bilang item na babayaran ng cash.",
  "Bill the LGU for assistance purchases. Payment goes to your bank account or as a check for pickup.": "Singilin ang LGU para sa mga binili gamit ang ayuda. Ang bayad ay papasok sa bank account mo o bilang tseke na kukunin.",
  "Billed": "Nasingil na",
  "Billing": "Billing",
  "Billing preview": "Silip sa billing",
  "Billing progress": "Takbo ng billing",
  "Bring your card. You will be asked for your PIN at the counter.": "Dalhin ang card mo. Hihingin ang PIN mo sa counter.",
  "Business name": "Pangalan ng negosyo",
  "Camera view for scanning barcodes": "Camera para sa pag-scan ng barcode",
  "Cancel": "Kanselahin",
  "Cancel billing": "Kanselahin ang billing",
  "Cancel sale": "Kanselahin ang benta",
  "Card ending {last}": "Card na nagtatapos sa {last}",
  "Card reader is on.": "Bukas na ang card reader.",
  "Cash collected": "Nakolektang cash",
  "Cashier": "Cashier",
  "Cashier: {name}": "Cashier: {name}",
  "Cashiers": "Mga cashier",
  "Check a valid ID first": "Suriin muna ang valid ID",
  "Checking the card…": "Sinusuri ang card…",
  "Choose a new 4-digit PIN": "Pumili ng bagong 4-digit na PIN",
  "Choose another item": "Pumili ng ibang item",
  "Choose how many of each item are returned. The amount goes back to the constituent's assistance balance.": "Piliin kung ilan sa bawat item ang ibinalik. Babalik ang halaga sa balanse ng ayuda ng constituent.",
  "Choose…": "Pumili…",
  "Clear": "Burahin",
  "Collect {amount} in cash": "Kolektahin ang {amount} na cash",
  "Constituent": "Constituent",
  "Constituent no. {no}": "Constituent blg. {no}",
  "Continue": "Magpatuloy",
  "Continue to PIN": "Tumuloy sa PIN",
  "Continue: {step}": "Ituloy: {step}",
  "Covered": "Sakop ng ayuda",
  "Create account": "Gumawa ng account",
  "DTI / SEC registration number": "Numero ng rehistro sa DTI / SEC",
  "Day": "Araw",
  "Day-end": "Pagsasara ng araw",
  "Day-end summary": "Buod sa pagsasara ng araw",
  "Delete last digit": "Burahin ang huling numero",
  "Device": "Device",
  "Device name": "Pangalan ng device",
  "Do not sell. Return the card and ask the person to visit the LGU office.": "Huwag magbenta. Ibalik ang card at sabihing pumunta sa opisina ng LGU.",
  "Documents": "Mga dokumento",
  "Done": "Tapos",
  "E-mail": "E-mail",
  "Each cashier signs in with their own account. Every sale records who made it.": "Bawat cashier ay may sariling account. Nakatala sa bawat benta kung sino ang gumawa.",
  "Enter your 4-digit PIN": "Ilagay ang iyong 4-digit na PIN",
  "Enter your invoice number before billing": "Ilagay ang invoice number bago maningil",
  "Explain why the LGU should reconsider": "Ipaliwanag kung bakit dapat muling isaalang-alang ng LGU",
  "Fill in only what changed.": "Punan lang ang nagbago.",
  "Find item": "Hanapin ang item",
  "Find the item on the approved list": "Hanapin ang item sa approved list",
  "From": "Mula",
  "Full name": "Buong pangalan",
  "Give these to the new cashier. The password is shown only now.": "Ibigay ito sa bagong cashier. Ngayon lang ipapakita ang password.",
  "Grocery": "Grocery",
  "Gross": "Kabuuan",
  "Hand the phone to the card owner. Do not look while they type.": "Iabot ang telepono sa may-ari ng card. Huwag tumingin habang nagta-type sila.",
  "Held": "Naka-hold",
  "Held by the LGU for review": "Hinold ng LGU para suriin",
  "History": "Kasaysayan",
  "Hold the assistance card flat on the back of the phone.": "Idikit nang pantay ang card ng ayuda sa likod ng telepono.",
  "Holdback": "Holdback",
  "I have read the agreement and accept it on behalf of the store.": "Nabasa ko ang kasunduan at tinatanggap ko ito para sa tindahan.",
  "ID number": "Numero ng ID",
  "ID photo added": "Naidagdag ang larawan ng ID",
  "ID type": "Uri ng ID",
  "Is this the person in front of you?": "Siya ba ang taong nasa harap mo?",
  "It can no longer be paid with assistance at your store.": "Hindi na ito mababayaran ng ayuda sa tindahan mo.",
  "It stops working as a POS at once. Lost or stolen phones should be removed right away.": "Agad itong hindi na gagana bilang POS. Alisin agad ang nawala o ninakaw na telepono.",
  "Item name": "Pangalan ng item",
  "Item paid in cash": "Item na babayaran ng cash",
  "Items": "Mga item",
  "Items not on the approved list are recorded on the slip but paid by the customer in cash.": "Ang mga item na wala sa approved list ay nakatala sa slip pero babayaran ng customer ng cash.",
  "Kept until review clears": "Itatabi hanggang matapos ang pagsusuri",
  "LGU note": "Paalala ng LGU",
  "Last sign-in {when}": "Huling sign-in {when}",
  "Last used {when}": "Huling ginamit {when}",
  "Less": "Bawasan",
  "Link your products to the LGU approved list. The LGU checks each one before it can be paid with assistance.": "Iugnay ang mga produkto mo sa approved list ng LGU. Sinusuri ng LGU ang bawat isa bago ito mabayaran ng ayuda.",
  "Map pin": "Pin sa mapa",
  "Memorandum of agreement": "Memorandum of agreement",
  "Mobile number": "Mobile number",
  "More": "Dagdagan",
  "My billings": "Aking mga billing",
  "Name on your shelf": "Pangalan sa istante mo",
  "Name, barcode or item code": "Pangalan, barcode o item code",
  "Name, birth date, photo and ID changes made at a store are checked by the LGU first.": "Ang pagbabago sa pangalan, kaarawan, larawan at ID na ginawa sa tindahan ay sinusuri muna ng LGU.",
  "Needs your invoice number": "Kailangan ng invoice number mo",
  "Net": "Net",
  "New PIN": "Bagong PIN",
  "New billing statement": "Bagong billing statement",
  "Next customer": "Susunod na customer",
  "No accredited stores here yet": "Wala pang accredited na tindahan dito",
  "No approved items found.": "Walang nakitang aprubadong item.",
  "No assistance balance that can be used at this store.": "Walang balanse ng ayuda na magagamit sa tindahang ito.",
  "No billings yet": "Wala pang billing",
  "No connection. Sales are not possible offline.": "Walang koneksiyon. Hindi puwedeng magbenta nang offline.",
  "No devices yet.": "Wala pang device.",
  "No items yet": "Wala pang item",
  "No longer on the approved list": "Wala na sa approved list",
  "No sales on this day": "Walang benta sa araw na ito",
  "No, not the same person": "Hindi, ibang tao",
  "Not on the approved list. Ask the LGU if it should be added.": "Wala sa approved list. Itanong sa LGU kung dapat itong idagdag.",
  "Not signed in yet": "Hindi pa nakapag-sign in",
  "Not used yet": "Hindi pa nagagamit",
  "Nothing here can be paid with assistance. Collect the full amount in cash.": "Wala ritong mababayaran ng ayuda. Kolektahin ang buong halaga ng cash.",
  "Only phones registered here can accept assistance cards. Use Chrome on an Android phone with NFC.": "Ang mga teleponong nakarehistro lang dito ang tatanggap ng card ng ayuda. Gamitin ang Chrome sa Android na may NFC.",
  "Open POS": "Buksan ang POS",
  "Open a sale to see its slip, add your invoice number, void it the same day or refund items.": "Buksan ang benta para makita ang slip, ilagay ang invoice number, i-void sa parehong araw o mag-refund ng item.",
  "Open the application": "Buksan ang aplikasyon",
  "Open this page on a registered POS device": "Buksan ang page na ito sa nakarehistrong POS device",
  "Other": "Iba pa",
  "Owner": "May-ari",
  "Owner's full name": "Buong pangalan ng may-ari",
  "PIN (4 to 6 digits)": "PIN (4 hanggang 6 na numero)",
  "PIN / info": "PIN / impormasyon",
  "PIN payments are locked for this card right now. The PIN can be reset with a valid ID.": "Naka-lock ngayon ang pagbabayad gamit ang PIN sa card na ito. Puwedeng i-reset ang PIN gamit ang valid ID.",
  "POS": "POS",
  "POS devices": "Mga POS device",
  "Paid": "Bayad na",
  "Paid in cash": "Bayad sa cash",
  "Paid to you": "Naibayad sa iyo",
  "Paid with assistance": "Bayad gamit ang ayuda",
  "Password": "Password",
  "Password again": "Ulitin ang password",
  "Pay in cash": "Bayaran ng cash",
  "Paying…": "Nagbabayad…",
  "Payment was released to your bank. Reference {ref}.": "Naipadala na ang bayad sa bangko mo. Reference {ref}.",
  "Pharmacies, groceries and sari-sari stores can accept the LGU assistance card. Create your account first.": "Ang mga botika, grocery at sari-sari store ay puwedeng tumanggap ng card ng ayuda ng LGU. Gumawa muna ng account.",
  "Pharmacy": "Botika",
  "Phone number or address": "Numero ng telepono o address",
  "Photo of {name}": "Larawan ni {name}",
  "Photos or PDF files, up to 10 MB each. Required documents are marked.": "Mga larawan o PDF, hanggang 10 MB bawat isa. May marka ang mga kailangang dokumento.",
  "Please hand the phone to the card owner.": "Paki-abot ang telepono sa may-ari ng card.",
  "Plus {amount} in cash": "Dagdag na {amount} na cash",
  "Prescription seen": "Nakita ang reseta",
  "Price (₱)": "Presyo (₱)",
  "Print": "I-print",
  "Print slip": "I-print ang slip",
  "Purok / sitio": "Purok / sitio",
  "Qty": "Dami",
  "Quantity": "Dami",
  "Ready to bill (last 90 days)": "Handang singilin (huling 90 araw)",
  "Reason": "Dahilan",
  "Reason from the LGU": "Dahilan mula sa LGU",
  "Record and end": "Itala at tapusin",
  "Ref": "Ref",
  "Refund": "Refund",
  "Refund items": "I-refund ang mga item",
  "Refunded": "Na-refund",
  "Refunds": "Mga refund",
  "Register this phone": "Irehistro ang teleponong ito",
  "Register this phone again": "Irehistro ulit ang teleponong ito",
  "Register this phone as a POS device to see sales here.": "Irehistro ang teleponong ito bilang POS para makita rito ang benta.",
  "Rejected": "Tinanggihan",
  "Remaining balance": "Natitirang balanse",
  "Remove": "Alisin",
  "Remove PIN": "Alisin ang PIN",
  "Remove device": "Alisin ang device",
  "Remove {name}?": "Alisin ang {name}?",
  "Removed": "Inalis",
  "Renew your accreditation": "I-renew ang akreditasyon mo",
  "Required": "Kailangan",
  "Reset the PIN with a valid ID": "I-reset ang PIN gamit ang valid ID",
  "Returned to constituents": "Ibinalik sa mga constituent",
  "Sale": "Benta",
  "Sales": "Mga benta",
  "Sales / voided": "Benta / na-void",
  "Sales are shown on the store's registered devices.": "Makikita ang benta sa mga nakarehistrong device ng tindahan.",
  "Sales billed": "Mga nasingil na benta",
  "Sales in this billing": "Mga benta sa billing na ito",
  "Sari-sari store": "Sari-sari store",
  "Save": "I-save",
  "Save PIN": "I-save ang PIN",
  "Save details": "I-save ang detalye",
  "Saved": "Naka-save",
  "Saved.": "Naka-save.",
  "Saved: {acct}. Type a new number only to change it.": "Naka-save: {acct}. Mag-type lang ng bagong numero kung papalitan.",
  "Scan": "I-scan",
  "Scan barcode": "I-scan ang barcode",
  "Search": "Hanapin",
  "Search your items": "Hanapin sa mga item mo",
  "Send appeal": "Ipadala ang apela",
  "Send to the LGU for approval": "Ipadala sa LGU para maaprubahan",
  "Sent to the LGU for approval": "Naipadala sa LGU para maaprubahan",
  "Sign in": "Mag-sign in",
  "Sign out": "Mag-sign out",
  "Start card reader": "Simulan ang card reader",
  "Statement PDF": "Statement PDF",
  "Status": "Katayuan",
  "Steps to accreditation": "Mga hakbang sa akreditasyon",
  "Still needed before you can submit:": "Kailangan pa bago makapagsumite:",
  "Stop": "Ihinto",
  "Stop camera": "Isara ang camera",
  "Store address": "Address ng tindahan",
  "Store details": "Detalye ng tindahan",
  "Store e-mail": "E-mail ng tindahan",
  "Store hours": "Oras ng tindahan",
  "Store invoice no.": "Invoice blg. ng tindahan",
  "Store mobile number": "Mobile number ng tindahan",
  "Store number": "Numero ng tindahan",
  "Store phone": "Telepono ng tindahan",
  "Store portal": "Portal ng tindahan",
  "Stores that accept the assistance card": "Mga tindahang tumatanggap ng card ng ayuda",
  "Street / house": "Kalye / bahay",
  "Submit application": "Isumite ang aplikasyon",
  "Submit billing to the LGU": "Isumite ang billing sa LGU",
  "Submit your application": "Isumite ang aplikasyon mo",
  "Supervisor": "Supervisor",
  "Supervisor PIN": "Supervisor PIN",
  "Supervisor PIN for {name}": "Supervisor PIN ni {name}",
  "Supporting list (Excel)": "Supporting list (Excel)",
  "Switch off": "Patayin",
  "Switch off {name}?": "Patayin ang account ni {name}?",
  "Switch on": "Buksan",
  "Switch on {name}?": "Buksan ang account ni {name}?",
  "Switched off": "Nakapatay",
  "TIN": "TIN",
  "Take a photo of the ID (optional)": "Kunan ng larawan ang ID (opsyonal)",
  "Tap": "I-tap",
  "Tap the card": "I-tap ang card",
  "Tap the map where your store is, so constituents can find it in the merchant directory.": "I-tap ang mapa kung nasaan ang tindahan mo, para makita ito ng mga constituent sa directory.",
  "Temporary password": "Pansamantalang password",
  "Test card number": "Numero ng test card",
  "Test mode: use a test card number": "Test mode: gumamit ng numero ng test card",
  "That is not an LGU assistance card.": "Hindi iyan card ng ayuda ng LGU.",
  "The LGU pays your billings to this account.": "Dito ibabayad ng LGU ang mga billing mo.",
  "The camera could not be opened. Allow camera access, or type the barcode.": "Hindi mabuksan ang camera. Payagan ang camera, o i-type ang barcode.",
  "The card reader could not start. Check that NFC is on in the phone settings.": "Hindi nagsimula ang card reader. Tingnan kung naka-on ang NFC sa settings ng telepono.",
  "The constituent will get an SMS about this change.": "Makakatanggap ng SMS ang constituent tungkol sa pagbabagong ito.",
  "The face on the ID matches the person and the photo shown on the POS.": "Tugma ang mukha sa ID sa tao at sa larawang nasa POS.",
  "The passwords do not match.": "Hindi magkatugma ang mga password.",
  "The person must be present and show a valid government ID matching {name}.": "Dapat naroon ang tao at magpakita ng valid na government ID na tugma kay {name}.",
  "The store owner registers it once: Store portal, then Devices, then Register this phone. Use Chrome on an Android phone with NFC.": "Isang beses itong irerehistro ng may-ari: Portal ng tindahan, Devices, saka Irehistro ang teleponong ito. Gamitin ang Chrome sa Android na may NFC.",
  "The two PINs were different. Start again.": "Magkaiba ang dalawang PIN. Ulitin.",
  "They are signed out at once and cannot sign in until switched on again.": "Agad silang masa-sign out at hindi makakapag-sign in hangga’t hindi binubuksan ulit.",
  "They choose their own password at the first sign-in.": "Pipili sila ng sariling password sa unang sign-in.",
  "This browser cannot read cards. Use Chrome on an Android phone with NFC switched on.": "Hindi makabasa ng card ang browser na ito. Gamitin ang Chrome sa Android na naka-on ang NFC.",
  "This browser cannot scan barcodes. Type the barcode instead.": "Hindi makapag-scan ng barcode ang browser na ito. I-type na lang ang barcode.",
  "This is not an official invoice.": "Hindi ito opisyal na resibo.",
  "This phone is not registered as a POS device": "Hindi nakarehistro ang teleponong ito bilang POS device",
  "This phone is registered as a POS device.": "Nakarehistro ang teleponong ito bilang POS device.",
  "To": "Hanggang",
  "Today's assistance sales": "Benta ngayong araw gamit ang ayuda",
  "Today's sales": "Benta ngayon",
  "Total assistance": "Kabuuang ayuda",
  "Total cash collected": "Kabuuang nakolektang cash",
  "Total refunds": "Kabuuang refund",
  "Transaction slip": "Slip ng transaksiyon",
  "Type a barcode": "I-type ang barcode",
  "Type of store": "Uri ng tindahan",
  "Type the new PIN again": "I-type ulit ang bagong PIN",
  "Update phone number or address": "I-update ang numero ng telepono o address",
  "Upload": "I-upload",
  "Uploaded": "Na-upload",
  "Uploaded on {date}": "Na-upload noong {date}",
  "Uploading…": "Nag-a-upload…",
  "Used to sign in. A temporary password will be made for them.": "Gagamitin sa pag-sign in. Gagawan sila ng pansamantalang password.",
  "Void sale": "I-void ang benta",
  "Voided": "Na-void",
  "Voiding cancels the whole sale and returns the full amount to the constituent's assistance balance. Only today's unbilled sales can be voided.": "Kinakansela ng void ang buong benta at ibinabalik ang buong halaga sa balanse ng ayuda ng constituent. Ang benta lang ngayong araw na hindi pa nasisingil ang puwedeng i-void.",
  "Waiting": "Naghihintay",
  "Waiting for LGU": "Hinihintay ang LGU",
  "What did you notice? (optional)": "Ano ang napansin mo? (opsyonal)",
  "What should change?": "Ano ang babaguhin?",
  "Yes, this is the person": "Oo, siya nga",
  "You accepted version {v} on {date}.": "Tinanggap mo ang bersyon {v} noong {date}.",
  "Your accreditation expires on {date}. Contact the LGU to renew it.": "Mag-e-expire ang akreditasyon mo sa {date}. Makipag-ugnayan sa LGU para i-renew.",
  "Your application was submitted. The LGU will evaluate it and inspect the store.": "Naisumite na ang aplikasyon mo. Susuriin ito ng LGU at iinspeksiyunin ang tindahan.",
  "Your barcode": "Iyong barcode",
  "Your check {no} is ready for pickup at {place}.": "Handa nang kunin ang tseke mo {no} sa {place}.",
  "Your last appeal": "Huling apela mo",
  "Your official invoice number": "Opisyal na invoice number mo",
  "Your price (₱)": "Presyo mo (₱)",
  "Your price is above the cap of {cap}.": "Lampas ang presyo mo sa cap na {cap}.",
  "Your store is accredited.": "Accredited na ang tindahan mo.",
  "Your store number is {no}. Sign in to complete your application: store details, documents and the agreement.": "Ang numero ng tindahan mo ay {no}. Mag-sign in para kumpletuhin ang aplikasyon: detalye ng tindahan, mga dokumento at kasunduan.",
  "assistance": "ayuda",
  "cap": "cap",
  "cash": "cash",
  "e.g. Mon–Sat 7:00 AM to 8:00 PM": "hal. Lun–Sab 7:00 AM hanggang 8:00 PM",
  "e.g. paracetamol, rice, milk": "hal. paracetamol, bigas, gatas",
  "invoice": "invoice",
  "of {total}": "sa {total}",
  "optional": "opsyonal",
  "prescription": "may reseta",
  "prescription only": "kailangan ng reseta",
  "price cap": "price cap",
  "refunded": "na-refund",
  "the LGU treasury": "ang treasury ng LGU",
  "this phone": "teleponong ito",
  "to": "hanggang",
  "will be paid from your assistance": "ay babayaran mula sa ayuda mo",
  "you": "ikaw",
  "{n} can be returned": "{n} ang puwedeng ibalik",
  "{n} of 4 digits entered": "{n} sa 4 na numero ang nailagay",
  "{n} sales are held by the LGU for review and cannot be billed yet.": "{n} benta ang hinold ng LGU para suriin at hindi pa masisingil.",
  "{n} sales are left out because they have no invoice number yet:": "{n} benta ang hindi kasama dahil wala pang invoice number:",
  "{n} sales ready to bill": "{n} benta ang handang singilin",
  "{n} sales still need your invoice number.": "{n} benta ang kailangan pa ng invoice number mo.",
  "Draft": "Draft",
  "Submitted": "Naisumite",
  "Under evaluation": "Sinusuri",
  "Accredited": "Accredited",
  "Suspended": "Suspendido",
  "Revoked": "Binawi",
  "Expired": "Expired",
  "Complete your store details": "Kumpletuhin ang detalye ng tindahan",
  "Upload the required documents": "I-upload ang mga kailangang dokumento",
  "Submit the application": "Isumite ang aplikasyon",
  "Accept the memorandum of agreement": "Tanggapin ang memorandum of agreement",
  "LGU evaluation and store inspection": "Pagsusuri ng LGU at inspeksiyon sa tindahan",
  "Under review": "Sinusuri",
  "On hold": "Naka-hold",
  "For payment": "Para sa bayad",
  "Released to your bank": "Naipadala sa bangko mo",
  "Check ready for pickup": "Handa nang kunin ang tseke",
  "Cancelled": "Kinansela",
  "DTI or SEC registration": "Rehistro sa DTI o SEC",
  "Mayor's / business permit": "Mayor's / business permit",
  "BIR Certificate of Registration (Form 2303)": "BIR Certificate of Registration (Form 2303)",
  "Sanitary permit": "Sanitary permit",
  "Proof of bank account (for payment)": "Patunay ng bank account (para sa bayad)",
  "FDA License to Operate (pharmacies)": "FDA License to Operate (para sa botika)",
  "Other supporting document": "Iba pang dokumento",
  "address": "address",
  "barangay": "barangay",
  "phone": "telepono",
  "email": "e-mail",
  "bank account for payment": "bank account para sa bayad",
  "Not on the approved list": "Wala sa approved list",
  "Prescription not confirmed": "Hindi pa nakumpirma ang reseta",
  "Balance not enough: the rest is paid in cash": "Kulang ang balanse: ang natitira ay babayaran ng cash",
  "No balance left for this category": "Wala nang balanse para sa kategoryang ito",
  "Above the price cap: the difference is paid in cash": "Lampas sa price cap: ang diperensiya ay babayaran ng cash",
  "PhilSys National ID": "PhilSys National ID",
  "Driver's license": "Lisensiya sa pagmamaneho",
  "UMID / SSS": "UMID / SSS",
  "Passport": "Pasaporte",
  "Voter's ID": "Voter's ID",
  "Senior citizen ID": "Senior citizen ID",
  "PWD ID": "PWD ID",
  "Postal ID": "Postal ID",
  "Barangay ID": "Barangay ID",
  "Other government ID": "Iba pang government ID",
};
